import { YesNoAllEnum } from 'Common/Constants/Enumeration/PropEnums';

/**
 *
 * @param {Object[]} sites - The array of sites to be filtered.
 * @param {string} sites[].Id
 * @param {string} sites[].PrimarySiteId
 * @param {boolean} sites[].IsActive
 * @param {boolean} sites[].IsLicensed
 * @param {number} sites[].SiteMasterTypeId
 * @param {number} sites[].AlternateProvisionTypeId
 *
 * @param {Object} options - The variables to be used while filtering.
 * @param {YesNoAllEnum} options.active
 * @param {YesNoAllEnum} options.licensed
 * @param {YesNoAllEnum} options.primary
 * @param {number[]} options.siteMasterTypeIds
 * @param {?number[]} options.alternateProvisionTypes
 *
 * @returns {Array} Returns filtered sites.
 */
export const filterSites = (sites, options) => {
  const {
    active,
    licensed,
    primary,
    siteMasterTypeIds,
    alternateProvisionTypes,
  } = {
    active: YesNoAllEnum.Yes,
    licensed: YesNoAllEnum.Yes,
    primary: YesNoAllEnum.Yes,
    siteMasterTypeIds: [1],
    alternateProvisionTypes: null,
    ...options,
  };

  // Filter out active or inactive based on the prop enum
  if (active !== YesNoAllEnum.All) {
    const isActive = active === YesNoAllEnum.Yes;
    sites = sites.filter((s) => s.IsActive === isActive);
  }

  // Filter out licensed or unlicensed based on the prop enum
  if (licensed !== YesNoAllEnum.All) {
    const isLicensed = licensed === YesNoAllEnum.Yes;
    sites = sites.filter((s) => s.IsLicensed === isLicensed);
  }

  // Filter out primary or secondary sites based on the prop enum
  if (primary !== YesNoAllEnum.All) {
    sites = sites.filter(
      primary === YesNoAllEnum.Yes
        ? (s) => s.Id === s.PrimarySiteId
        : (s) => s.Id !== s.PrimarySiteId
    );
  }

  // Filter out Types that aren't in the list of siteMasterTypeIds.
  sites = sites.filter((s) => siteMasterTypeIds.includes(s.SiteMasterTypeId));

  // If a list of Alternate Provision Types is passed, filter out any not in the list.
  if (alternateProvisionTypes) {
    sites = sites.filter((s) =>
      alternateProvisionTypes.includes(s.AlternateProvisionTypeId)
    );
  }

  return sites;
};



// WEBPACK FOOTER //
// ./src/common/Helpers/filters.js